"use strict";

var AbstractPledgeManagementHelper = require("./AbstractPledgeManagementHelper");
var AccountStore = require("./AccountStore");

var Spinner = require("../client/Spinner");

var AccountApi = require("../api/AccountApi");

var WizardConstants = require("../constants/WizardConstants");

var BootstrapPrompt = require("../shared/BootstrapPrompt");

var MyPledgesHelper = class extends AbstractPledgeManagementHelper {
	constructor() {
		var donateToAllCheckboxComponentName = "myRelationshipPledgesDonateToAll";
		var donateToSingleCheckboxComponentName = "myRelationshipPledgesDonateToSingle";

		super({
			componentSelector: "[data-component='myRelationshipPledges']",
			displayMessagesWizard: "wizardMyPledgesDisplayMessages",
			donateToAllCheckboxComponentName,
			donateToAllCheckboxSelector: `[data-component="${donateToAllCheckboxComponentName}"]`,
			donateToAllCheckboxInputSelector: `[data-component="${donateToAllCheckboxComponentName}.input"]`,
			donateToSingleCheckboxComponentName,
			donateToSingleCheckboxSelector: `[data-component="${donateToSingleCheckboxComponentName}"]`,
			donateToSingleCheckboxInputSelector: `[data-component="${donateToSingleCheckboxComponentName}.input"]`,
			makeDonationSelector: "[data-component='myRelationshipPledgesMakeDonation']",
			singlePledgeSelector: "[data-component='myRelationshipPledges.populated.singleRelationshipPledge']"
		});
	}

	makeDonation(event, isDesignMode) {
		var $myRelationshipPledgesComponent = $(event.target).closest(this.componentSelector);
		var relationshipType = $myRelationshipPledgesComponent.attr("data-relationship-type");
		var relationshipRelatedType = $myRelationshipPledgesComponent.attr("data-relationship-related-type");

		return super.makeDonation(event, isDesignMode, (pledgeIds) => {
			var shortComment;
			if (typeof window.makeDonationToPledgeShortComment === 'string' || window.makeDonationToPledgeShortComment instanceof String) {
				shortComment = window.makeDonationToPledgeShortComment;
			}

			AccountApi.myRelationshipPledgesMakeDonation({ pledgeIds }, relationshipType, relationshipRelatedType, shortComment).done((response) => {
				window.location = "/shoppingcart";
			}).fail(() => {
				BootstrapPrompt.alert(AccountStore.getWizardValue(
					WizardConstants.WIZARDS.SHOPPING_CART_MESSAGES,
					WizardConstants.SHOPPING_CART_MESSAGE_FIELDS.ADD_TO_CART_ERROR,
					{ tangibleType: "donation(s)" }
				));
				Spinner.removeSpinner();
			});
		});
	}

	initializeMyRelationshipPledges($component, isDesignMode) {
		super.initializeComponent($component, isDesignMode);
	}
};

module.exports = new MyPledgesHelper();